import Room from "../../components/room/Room";
const tabs = [
  { id: "1", title: "Phòng 1", content: <Room id="1" /> },
  { id: "2", title: "Phòng 2", content: <Room id="2" /> },
  { id: "3", title: "Phòng 3", content: <Room id="3" /> },
  { id: "4", title: "Phòng 4", content: <Room id="4" /> },
  { id: "5", title: "Phòng 5", content: <Room id="5" /> },
  { id: "6", title: "Phòng 6 Vip", content: <Room id="6V" /> },
  { id: "7", title: "Phòng 7 Vip ", content: <Room id="7V" /> },
  { id: "8", title: "Phòng 8 Vip", content: <Room id="8V" /> },
  { id: "9", title: "Phòng 9 Vip", content: <Room id="9V" /> },
  { id: "10", title: "Phòng 10 Vip", content: <Room id="10V" /> },
];

export default tabs;

